<template>
    <div class="NameLang">
      <el-form label-width="100px" label-position="right">
        <el-form-item :label="lan.name" v-for="lan in languages">
          <el-input v-model="lan.value" :placeholder="lan.name" @input="input_test"></el-input>
        </el-form-item>
      </el-form>
      <el-button type="danger" :loading="loading" @click="trans" style="margin-top: 20px;">自动翻译</el-button>
    </div>
  </template>
  
  <script>
import { deep_seek_trans, get_languages } from '../../api/api';
import { isJSON } from '../../utils';

    export default {
      name: 'name-lang',
     
      props:{
        reset:{
            type:Boolean,
            default:false
        },
        edit_lan:{
            type:String|null,
            default:''
        }
      },
      data() {
        return {
          languages:[],
          /*
          {1:你好,2:hello}
          */
          json_lans:{},
          loading:false

        };
      },
     
      mounted(){
        this.refresh_languages()
      },

      computed: {
       
      },
      watch:{
        reset(newV,oldV){
            console.log('reset',newV)
            if(newV){
                // this.refresh_languages()
                this.languages.forEach(lan=>{
                    lan.value = '';
                })
                this.$forceUpdate()
            }
        },
        edit_lan(newV){
            // console.log('edit_lan',newV)
            if(newV){
                this.lans_to_value()        
            }
            
        }
      },
      methods: {
        refresh_languages(){

            get_languages()
            .then(res=>{
               
                this.languages =  JSON.parse(JSON.stringify(res.list));
                this.lans_to_value()
            })
            
        },
        lans_to_value(){
          if(!this.edit_lan.length){
            return
          }
          const is_json = isJSON(this.edit_lan);
                
          if(is_json){
              const lan_objct = JSON.parse(this.edit_lan);
              this.languages.forEach(lan=>{
                  lan.value = lan_objct[lan.id];
              })
              this.$forceUpdate()
          }else{
              this.languages[0].value = this.edit_lan
          }

          this.input_test()
        },
        input_test(){
           
            var lan_json = {}
            this.languages.forEach(lan=>{
                if(lan.value && lan.value.length){
                    lan_json[lan.id]=lan.value
                }
            })
            this.json_lans = lan_json;
            this.$forceUpdate()
            // console.log('input_test',e,this.languages,this.json_lans)
            this.$emit('lang_change',this.json_lans)
        },
        async trans(){
          const chinese = this.languages.filter(lan=>{
            return lan.ecode == "zh"
          })[0]
          if(!chinese.value || !chinese.value.length){
            this.$message({
              message:'请先输入中文',
              type:'error'
            })
            return;
          }

          this.loading = true
          try {
            const result = await deep_seek_trans({
              content:chinese.value,
              languages:this.languages
            })
         
            this.languages.forEach(lan=>{
              lan.value = result[lan.ecode]
           
            })
            this.loading = false
            this.input_test()
            this.$forceUpdate()
           
          } catch (error) {
            this.loading = false
            this.$message({
              message:error,
              type:'error'
            })
          }
          
        }
      },
    };
  </script>
  
  <style lang="less" src="./NameLang.less"></style>
  